import React from 'react';
import { withStyles, Grid, Typography, withRouter } from '../../../material-ui';

import MSectionHeader from '../../view/MSectionHeader';
import MatchType from '../../../model/MatchType';
import DataUtils from '../../../model/DataUtils';

class MatchPlayerTechnical extends React.Component {

    constructor(props) {
        super(props);

        let skills = [];
        let data = this.props.location.data;
        if (data) {
            let type_id = data.type_id;
            if (type_id == MatchType.BASKETBALL) {
                skills = DataUtils.getBasketBallSkillList(data);
            } else if (type_id == MatchType.FOOTBALL) {
                skills = DataUtils.getFootBallSkillList(data);
            }
        }

        console.log('MatchPlayerTechnical', props);
        console.log('MatchPlayerTechnical', skills);
        this.state = { skills: skills, };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _renderItem = (name, value, i) => {
        return (
            <Grid key={i} container direction='row' justifyContent='space-between' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 4 }}>
                <Typography style={{ fontSize: 12, color: '#878787' }}>{name}</Typography>
                <Typography style={{ fontSize: 12, color: '#878787' }}>{value}</Typography>
            </Grid>
        );
    }

    render() {
        const { skills } = this.state;
        let keys = Object.keys(skills);
        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                {
                    keys.map((item, i) => (
                        <Grid key={i} container direction='column'  >
                            <MSectionHeader title={item} />
                            {
                                skills[item] && skills[item].map((obj, j) => (
                                    this._renderItem(obj.name, obj.value, j)
                                ))
                            }
                        </Grid>


                    ))
                }
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: '#FC182B',
        color: '#FFF',
        borderRadius: 4,
        width: 75,
        height: 25,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#FC182B'
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchPlayerTechnical));